import Link from "next/link";

// Breadcrumbs on every subpage: links grey and underlined, the current page in full text colour. Phones and
// tablets only (below 961 px, where the menu hides behind the burger); on desktop the highlighted menu item says it.
export default function Breadcrumbs({ trail }: { trail: { href?: string; label: string }[] }) {
  const all = [{ href: "/", label: "Start" }, ...trail];
  return (
    <nav aria-label="Brotkrümelnavigation" className="text-[15px] min-[961px]:hidden">
      <ol className="m-0 flex list-none flex-wrap items-center gap-2 p-0">
        {all.map((c, i) => {
          const last = i === all.length - 1;
          return (
            <li key={i} className="flex items-center gap-2">
              {last || !c.href ? (
                <span aria-current={last ? "page" : undefined} className="font-semibold text-ink">
                  {c.label}
                </span>
              ) : (
                <Link href={c.href} className="text-ink-2 underline underline-offset-2 hover:text-accent">
                  {c.label}
                </Link>
              )}
              {!last && (
                <span aria-hidden="true" className="text-ink-3">
                  /
                </span>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
